import React from 'react';
import { Dropdown, Tooltip } from 'antd';
import { MoreOutlined, CopyOutlined } from '@ant-design/icons';
import StatusBadge from '@/components/ui/StatusBadge';
import Link from '@/components/ui/Link';

export const getEmployeeColumns = ({
    handleCopyEmail,
    handleActionClick,
    canUpdate,
    canDelete,
    canRequestHrRemoval,
    canRemoveUser,
    hasPendingRemoval,
}) => [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (_, record) => {
            const email = record.email;
            if (!email) return '—';
            return (
                <span onClick={(e) => e.stopPropagation()}>
                    <Link href={`mailto:${email}`} style={{ marginRight: 8 }}>
                        {email}
                    </Link>
                    <Tooltip title="Copy email">
                        <CopyOutlined
                            style={{ cursor: 'pointer', color: 'var(--ant-color-text-tertiary)', fontSize: 14 }}
                            onClick={(e) => handleCopyEmail(email, e)}
                        />
                    </Tooltip>
                </span>
            );
        },
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (_, record) => <StatusBadge status={record.status} />,
    },
    {
        title: 'Roles',
        key: 'roles',
        width: 160,
        render: (_, record) => (record.roles?.length ? record.roles.map((r) => r.name).join(', ') : '—'),
    },
    {
        title: 'Schedule',
        key: 'schedule',
        width: 200,
        render: (_, record) => {
            const sg = record.scheduleGroup;
            if (!sg) return '—';
            const daysCount = Array.isArray(sg.workingDays) ? sg.workingDays.length : 0;
            const daysText = `${daysCount} ${daysCount === 1 ? 'day' : 'days'}`;
            const timeRange = (sg.startTime && sg.endTime) ? `${sg.startTime} - ${sg.endTime}` : '';
            return timeRange ? `${timeRange} (${daysText})` : daysText;
        },
    },
    {
        title: 'Enrolled',
        key: 'enrolled',
        width: 140,
        render: (_, record) => {
            const hasFinger = record.thumbId && record.thumbId.trim().length > 0;
            const hasRfid = record.rfid && record.rfid.trim().length > 0;
            if (hasFinger && hasRfid) return `Finger Slot ${record.thumbId} + RFID`;
            if (hasFinger) return `Finger Slot ${record.thumbId}`;
            if (hasRfid) return 'RFID';
            return 'No';
        },
    },
    {
        title: 'Action',
        key: 'action',
        width: 80,
        render: (_, record) => {
            const items = [
                { key: 'view', label: 'View' },
                { key: 'attendance_detail', label: 'Get Attendance Detail' },
                ...(canUpdate ? [{ key: 'edit', label: 'Edit' }] : []),
                ...(canRequestHrRemoval && !hasPendingRemoval(record)
                    ? [{ key: 'request_removal', label: 'Request removal', danger: true }]
                    : []),
                ...(canRemoveUser ? [{ key: 'remove_user', label: 'Remove User', danger: true }] : []),
                ...(canDelete ? [{ key: 'delete', label: 'Delete', danger: true }] : []),
            ].filter(Boolean);
            return (
                <span onClick={(e) => e.stopPropagation()}>
                    <Dropdown
                        menu={{
                            items,
                            onClick: (info) => handleActionClick(info, record),
                        }}
                        trigger={['click']}
                    >
                        <span style={{ cursor: 'pointer' }}>
                            <MoreOutlined />
                        </span>
                    </Dropdown>
                </span>
            );
        },
    },
];
